import { Divider, FlexAligner } from '@scaleaq/scaleui';

import { FooterObject } from './card.types.ts';
import { FooterBox } from './FooterBox.tsx';

export const WidgetFooterComponent = (footerComponents?: FooterObject) => {
  return (
    footerComponents && (
      <FlexAligner direction='column'>
        <Divider orientation='horizontal' color='soft_strong' />
        <FlexAligner scaling={1}>
          <FooterBox {...footerComponents.left} />
          <Divider orientation='vertical' color='soft_strong' />
          <FooterBox {...footerComponents.right} />
        </FlexAligner>
        {footerComponents.bottom && (
          <>
            <Divider orientation='horizontal' color='soft_strong' />
            <FooterBox {...footerComponents.bottom} />
          </>
        )}
        {footerComponents.veryBottom && (
          <>
            <Divider orientation='horizontal' color='soft_strong' />
            <FlexAligner scaling={1} spaceBetween>
              {footerComponents.veryBottom.map((footerBoxProps, index) => (
                <div key={index}>
                  <FooterBox
                    fullWidth={false}
                    key={index}
                    {...footerBoxProps}
                    alignment={footerBoxProps.alignment || 'center'}
                  />
                  {footerComponents.veryBottom &&
                    index < footerComponents.veryBottom.length - 1 && (
                      <Divider orientation='vertical' color='soft_strong' />
                    )}
                </div>
              ))}
            </FlexAligner>
          </>
        )}
      </FlexAligner>
    )
  );
};
